
import React from 'react';
import PropTypes from 'prop-types';
import { Container as SemanticContainer } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import prettybytes from 'pretty-bytes';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';
import config from '@plone/volto/registry';
import background from '../Header/SAW-Logo_farbig-positiv_RGB.svg';
/**
 * TitleHeader component class.
 * @function TitleHeader
 * @params {object} content Content object.
 * @returns {string} Markup of the component.
 */
const TitleHeader = ({ content }) => {
  const Image = config.getComponent({ name: 'Image' }).component;
  const Container =
    config.getComponent({ name: 'Container' }).component || SemanticContainer;

  return (
    <Container className="view-wrapper page-header title-header">

      {content?.lc_image?.download && (

        <Image
          item={content}
          imageField="lc_image"
          alt={content.title}
          responsive={true}
          description="test"
        />

      )}
      <div className='title-header-content'>
        <h1 className="documentFirstHeading title-heading">
          {content.title}
        </h1>
        {content?.description && (
          <p className="description">{content.description}</p>
        )}
      </div>
      <div className="overlay" style={{ backgroundImage: `url(${background})` }}></div>

    </Container>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
TitleHeader.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    portrait: PropTypes.shape({
      scales: PropTypes.shape({
        preview: PropTypes.shape({
          download: PropTypes.string,
        }),
      }),
    }),
  }).isRequired,
};

export default TitleHeader;
